// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._49751c{cursor:pointer;background:var(--gray);width:2em;border-radius:10em;transition:.25s cubic-bezier(0.65, 0.05, 0.36, 1);align-self:center;box-shadow:0 0 0 .25em var(--gray)}._49751c.cb21a9{background:var(--primary);box-shadow:0 0 0 .25em var(--primary)}.d9ec72{background:currentColor;width:1em;height:1em;border-radius:10em;transition:.25s cubic-bezier(0.65, 0.05, 0.36, 1)}.d9ec72:not(.cb21a9){opacity:.33}.d9ec72.cb21a9{transform:translateX(100%);background:#fff}", ""]);
// Exports
exports.locals = {
	"track": "_49751c",
	"on": "cb21a9",
	"handle": "d9ec72"
};
module.exports = exports;
